export interface CockpitActivity {
  readonly date: number;
  readonly type: string;
  readonly person?: string;
  readonly email?: string;
  readonly phone?: string;
  readonly data?: Record<string, unknown>;
}

export interface CockpitEvent {
  readonly date: string;
  readonly booked?: boolean;
  readonly bookedBy?: string;
  readonly bookedByEmail?: string;
  readonly bookedByPhone?: string;
  readonly hostedBy?: string;
}

export function flattenActivities(
  input: Record<string, CockpitActivity[]> | CockpitActivity[] | undefined,
): CockpitActivity[] {
  const list = Array.isArray(input) ? input : Object.values(input ?? {}).flat();
  return [...list].sort((a, b) => b.date - a.date);
}

export function diffToAsking(
  offer: number,
  asking: number,
): { readonly pct: number; readonly label: string } | null {
  if (!asking || !offer) return null;
  const pct = Math.round(((offer - asking) / asking) * 1000) / 10;
  return { pct, label: `${pct > 0 ? '+' : ''}${pct} %` };
}

export const DOCUMENT_TYPE_LABELS: Record<string, string> = {
  expose: 'Exposé',
  flyer: 'Flyer',
  seller_contract: 'Verkaufsvertrag',
  land_register: 'Grundbuchauszug',
  floor_plan: 'Grundrissplan',
  energy_certificate: 'Energieausweis',
  photo: 'Foto',
  contract: 'Vertrag',
  certificate: 'Zertifikat',
  plan: 'Plan',
  document: 'Dokument',
};

export function groupByDay<T extends { readonly date: string | number }>(
  items: readonly T[],
): [string, T[]][] {
  const out = new Map<string, T[]>();
  for (const item of items) {
    const ms = new Date(
      typeof item.date === 'string' && /^\d+$/.test(item.date)
        ? Number(item.date)
        : item.date,
    );
    const key = Number.isNaN(ms.getTime())
      ? ''
      : ms.toLocaleDateString('sv-SE');
    out.set(key, [
      ...(out.get(key) ?? []),
      item,
    ]);
  }
  return [...out.entries()];
}

// Loader widgetProps are untyped JSON keyed by widget name.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type WidgetProps = Record<string, any>;
